import { useState } from "react";
import { LockKeyhole } from "lucide-react";
import { Button } from "@web/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader } from "@web/components/ui/card";
import { ThemeToggleButton } from "@web/components/features/theme-toggle-button";
import { Input } from "@web/components/ui/input";
import type { ReaderWorkspace } from "../reader/reader-workspace";

interface LoginPageProps {
  workspace: ReaderWorkspace;
}

export function LoginPage({ workspace }: LoginPageProps) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const loginDisabled = workspace.busy || !username.trim() || !password.trim();

  async function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setError("");

    try {
      await workspace.handleLogin(username, password);
    } catch (nextError) {
      setError(nextError instanceof Error ? nextError.message : String(nextError));
    }
  }

  return (
    <main className="fixed inset-0 flex h-dvh max-h-dvh items-center justify-center overflow-hidden bg-background px-4 text-foreground">
      <div className="absolute right-[max(1rem,env(safe-area-inset-right))] top-[max(1rem,env(safe-area-inset-top))]">
        <ThemeToggleButton theme={workspace.preference.theme} onToggle={workspace.handleToggleTheme} />
      </div>

      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto flex size-12 items-center justify-center rounded-full bg-primary text-primary-foreground">
            <LockKeyhole className="size-5" />
          </div>
        </CardHeader>

        <form onSubmit={handleSubmit}>
          <CardContent className="space-y-4">
            <label className="block space-y-2">
              <span className="text-sm font-medium">账号</span>
              <Input value={username} onChange={event => setUsername(event.target.value)} autoComplete="username" required />
            </label>
            <label className="block space-y-2">
              <span className="text-sm font-medium">密码</span>
              <Input
                type="password"
                value={password}
                onChange={event => setPassword(event.target.value)}
                autoComplete="current-password"
                required
              />
            </label>

            {error ? <p className="rounded-md border border-destructive/30 bg-destructive/10 px-3 py-2 text-sm text-destructive">{error}</p> : null}
          </CardContent>

          <CardFooter className="pt-4">
            <Button type="submit" disabled={loginDisabled} className="w-full">
              {workspace.busy ? "登录中" : "登录"}
            </Button>
          </CardFooter>
        </form>
      </Card>
    </main>
  );
}
